
export function state () {
    return {
        lastId: 6,
        comments: [],
        commentDict: {}
    }
}